import { render, staticRenderFns } from "./bannersConsorcios.vue?vue&type=template&id=471d5afb&scoped=true&"
import script from "./bannersConsorcios.ts?vue&type=script&lang=ts&"
export * from "./bannersConsorcios.ts?vue&type=script&lang=ts&"
import style0 from "./bannersConsorcios.vue?vue&type=style&index=0&id=471d5afb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471d5afb",
  null
  
)

export default component.exports